import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../common/SEO';
import TechDeepDive from '../components/TechDeepDive';
import SafeIcon from '../common/SafeIcon';

const TechPage = () => {
  return (
    <>
      <SEO 
        title="Technologie LEDBAR – Špičková optika a LED čipy | LightWell"
        description="Detailní pohled na technologie LightWell: hliníkové nosiče tepla, PMMA optické čočky a originální LED čipy XIAMEN SANAN pro maximální účinnost."
        path="/technologie"
      />
      <div className="pt-20">
        <section className="bg-gray-50 py-24 border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase text-gray-900">Naše Technologie</h1>
            <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto">Využíváme pouze certifikované komponenty od světových lídrů v oboru polovodičů a optiky.</p>
            <div className="mt-10 flex justify-center">
              <Link to="/produkty/ledbary" className="flex items-center gap-2 text-blue-600 font-bold uppercase tracking-widest text-xs hover:gap-4 transition-all">
                Přejít do katalogu produktů <SafeIcon name="ArrowRight" />
              </Link>
            </div>
          </div>
        </section>
        <TechDeepDive />
      </div>
    </>
  );
};

export default TechPage;